// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".doctitle{display:inline-block}", "",{"version":3,"sources":["webpack://./src/pages/search/results/table/DocRow.vue"],"names":[],"mappings":"AACA,UAEC,oBAAA","sourcesContent":["\n.doctitle {\n\t// Make line clickable when links wraps onto next line.\n\tdisplay: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
